import { useGetIdentity, useLogout } from '@refinedev/core'
import { Layout, Avatar, Dropdown, Typography, Modal, Space, theme } from 'antd'
import { UserOutlined, LogoutOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'

const { Text } = Typography
const { useToken } = theme

interface Identity {
  id: string
  name: string
  email: string
  avatar?: string
  role: string
}

export const Header = () => {
  const { token } = useToken()
  const { data: identity } = useGetIdentity<Identity>()
  const { mutate: logout } = useLogout()

  const handleLogout = () => {
    Modal.confirm({
      title: 'Odjava',
      icon: <ExclamationCircleOutlined />,
      content: 'Da li ste sigurni da zelite da se odjavite?',
      okText: 'Da, odjavi me',
      cancelText: 'Odustani',
      okButtonProps: { danger: true },
      onOk: () => {
        logout()
      },
    })
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '4px 0' }}>
          <Text strong>{identity?.name || identity?.email}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>
            {identity?.role}
          </Text>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: 'Odjavi se',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout,
    },
  ]

  return (
    <Layout.Header
      style={{
        backgroundColor: token.colorBgElevated,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0 24px',
        height: 64,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Text>{identity?.name || identity?.email}</Text>
          <Avatar
            src={identity?.avatar}
            icon={!identity?.avatar && <UserOutlined />}
            style={{ backgroundColor: token.colorPrimary }}
          />
        </Space>
      </Dropdown>
    </Layout.Header>
  )
}
